import { render } from "./InputFile.vue?vue&type=template&id=47f62c8c&scoped=true&ts=true&lang=pug"
import script from "./InputFile.vue?vue&type=script&lang=ts&setup=true"
export * from "./InputFile.vue?vue&type=script&lang=ts&setup=true"

import "./InputFile.vue?vue&type=style&index=0&id=47f62c8c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f62c8c"]])

export default __exports__